var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-lg-6 lbv-admin" },
      [
        _c(
          "b-card",
          { attrs: { header: "Remove device from user" } },
          [
            _c(
              "div",
              { staticClass: "form-row" },
              [
                _c(
                  "b-btn",
                  {
                    directives: [
                      {
                        name: "b-modal",
                        rawName: "v-b-modal.modal1",
                        modifiers: { modal1: true },
                      },
                    ],
                    staticClass: "removeDevice",
                    attrs: { variant: "primary" },
                    on: {
                      click: function ($event) {
                        _vm.showModal = true
                      },
                    },
                    model: {
                      value: _vm.removeDevice,
                      callback: function ($$v) {
                        _vm.removeDevice = $$v
                      },
                      expression: "removeDevice",
                    },
                  },
                  [_vm._v("\n          Remove Device From User\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                attrs: {
                  id: "modal1",
                  title: "Remove device",
                  "ok-variant": "danger",
                  "ok-title": "Remove device",
                  "cancel-variant": "primary",
                  "cancel-title": "Cancel",
                },
                on: { ok: _vm.RemoveModalDevice },
              },
              [
                _c("p", [
                  _c("strong", [_vm._v("Removing a device cannot be undone.")]),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n          By removing a device the account will no longer be available for the user or admin/ops."
                  ),
                  _c("br"),
                  _vm._v(
                    "\n          Are you sure you want to remove device from this user?\n        "
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-lg-6 lbv-admin" },
      [
        _c("b-card", { attrs: { header: "Analysing Mode" } }, [
          _c(
            "div",
            { staticClass: "form-row" },
            [
              _c("div", { staticClass: "btnCtrl" }, [
                _c(
                  "label",
                  {
                    staticClass:
                      "switch switch-text switch-pill switch-secondary",
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.modalAnalysingMode",
                          modifiers: { modalAnalysingMode: true },
                        },
                      ],
                      ref: "switchBtn",
                      staticClass: "switch-input",
                      attrs: { type: "checkbox", variant: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showModal = true
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "switch-label",
                      attrs: { "data-on": "On", "data-off": "Off" },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "switch-handle" }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "modalAnalysingMode",
                    "ok-variant": "primary",
                    "ok-title": "Yes",
                    "cancel-title": "Cancel",
                  },
                  on: {
                    ok: _vm.setAnalysingMode,
                    cancel: _vm.cancelAnalysingMode,
                  },
                },
                [
                  _c("p", { staticClass: "bolder" }, [
                    _vm._v(
                      "\n            Are you sure you want to set/unset this device to analysing mode?\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "bold" }, [
                    _vm._v(
                      "\n            This will trigger new comms to be sent to the customer.\n          "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Remember to select the reason for switching device to analysing mode from the options provided."
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 left" },
                [
                  _c("legend", [_vm._v("Install Environment:")]),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        plain: true,
                        value: "1",
                        "unchecked-value": "0",
                        value: 1,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.installEnvironment($event)
                        },
                      },
                      model: {
                        value: _vm.headerTank,
                        callback: function ($$v) {
                          _vm.headerTank = $$v
                        },
                        expression: "headerTank",
                      },
                    },
                    [_vm._v("\n            Header Tank\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        plain: true,
                        value: "1",
                        "unchecked-value": "0",
                        value: 1,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.installEnvironment($event)
                        },
                      },
                      model: {
                        value: _vm.hotPipeEnvironment,
                        callback: function ($$v) {
                          _vm.hotPipeEnvironment = $$v
                        },
                        expression: "hotPipeEnvironment",
                      },
                    },
                    [_vm._v("\n            Hot Pipe Environment\n          ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-4 left" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        plain: true,
                        value: "1",
                        "unchecked-value": "0",
                        value: 1,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.installEnvironment($event)
                        },
                      },
                      model: {
                        value: _vm.underfloorHeating,
                        callback: function ($$v) {
                          _vm.underfloorHeating = $$v
                        },
                        expression: "underfloorHeating",
                      },
                    },
                    [_vm._v("\n            Underfloor Heating\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        plain: true,
                        value: "1",
                        "unchecked-value": "0",
                        value: 1,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.installEnvironment($event)
                        },
                      },
                      model: {
                        value: _vm.coldVoid,
                        callback: function ($$v) {
                          _vm.coldVoid = $$v
                        },
                        expression: "coldVoid",
                      },
                    },
                    [_vm._v("\n            Cold Void\n          ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: {
                        plain: true,
                        value: "1",
                        "unchecked-value": "0",
                        value: 1,
                      },
                      on: {
                        input: function ($event) {
                          return _vm.installEnvironment($event)
                        },
                      },
                      model: {
                        value: _vm.unknown,
                        callback: function ($$v) {
                          _vm.unknown = $$v
                        },
                        expression: "unknown",
                      },
                    },
                    [_vm._v("\n            Unknown\n          ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }